import React from 'react';
import { Box, Icon, ListItemButton, ListItemText } from '@mui/material';

export default function AccountList(props) {
    const { label, link, icon } = props

    return (
        <ListItemButton
        key={label}
        onClick={link}
        sx={{ py: 0, 
            minHeight: 40, 
            color: 'rgba(255,255,255,1)', 
            bgcolor: '#282828',
            '&:hover': {
                backgroundColor: '#404040', // Change this to your desired hover color
              },
            }}>
        <Box 
            paddingRight="15px"
            paddingBottom="1px">
            <Icon sx={{ color: 'inherit', }}>
                {icon}
            </Icon>
        </Box>
        <ListItemText
            primary={label}
            primaryTypographyProps={{ fontSize: 14, fontWeight: 'medium', }} />
        </ListItemButton>
    )
}